import { IconContent } from '@icons';

export const padlockOpenedFilled: IconContent = {
    sm: '<path fill-rule="evenodd" d="M6 5a2 2 0 1 0-4 0v1H1V5a3 3 0 0 1 6 0v2h6v7H3V7h3V5Zm1.5 4h1v2h-1V9Z" />',
    md: '<path fill-rule="evenodd" d="M10 7.5a2.5 2.5 0 0 0-5 0V9H4V7.5a3.5 3.5 0 1 1 7 0V11h9v9H6v-9h4V7.5Zm2.5 5.5h1v3h-1v-3Z" />',
};
